const SuperAdminHome = () => {
  return (
    <div className="w-full h-full flex items-center justify-center text-3xl font-bold">
      Super Admin Panel Placeholder
    </div>
  );
};

export default SuperAdminHome;
